import LoginPage from '@/pages/LoginPage'
import ResultPage from '@/pages/UploadBankPage'
import UploadRemittance from '@/pages/UploadRemittancePage'
import CompareTransactions from '@/pages/CompareTransactionsPage'
import CompletePage from '@/pages/CompletePage'
import Vue from 'vue'
import Router from 'vue-router'
import authService from '@/services/auth'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: LoginPage,
            meta: { requiresAuth: false }
        },
        {
            path: '/',
            name: 'ResultPage',
            component: ResultPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/upload_remittance',
            name: 'UploadRemittance',
            component: UploadRemittance,
            meta: { requiresAuth: true }
        },
        {
            path: '/compare_transactions',
            name: 'CompareTransactions',
            component: CompareTransactions,
            meta: { requiresAuth: true }
        },
        {
            path: '/complete',
            name: 'CompletePage',
            component: CompletePage,
            meta: { requiresAuth: true }
        }
    ]
})

// Navigation guard - protect routes that require authentication
router.beforeEach((to, from, next) => {
    // Initialize auth service if not already done
    if (!authService.initialized) {
        authService.initialize()
    }

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false)

    if (requiresAuth && !authService.isAuthenticated()) {
        // Redirect to login
        next({ name: 'Login' })
    } else if (to.name === 'Login' && authService.isAuthenticated()) {
        // Already logged in, redirect to home
        next({ name: 'ResultPage' })
    } else {
        next()
    }
})

export default router